import { useWorkOSAuthContext } from '~/common/contexts/WorkOSAuthContext'
import { useTypedTranslation } from '~/common/hooks/useTypedTranslation'
import { cn } from '../@/lib/utils'

export const IMPERSONATION_BANNER_HEIGHT = 36

/**
 * Renders a warning banner when the current session is an impersonation session.
 * Shows both the impersonator's email and the user being impersonated, with a Stop button.
 */
export const ImpersonationBanner = () => {
  const { t } = useTypedTranslation()
  const { impersonator, user, signOut } = useWorkOSAuthContext()

  if (!impersonator || !user) {
    return null
  }

  const userName = `${user.firstName} ${user.lastName}`.trim() || user.email

  return (
    <div
      className={cn(
        'h-9 flex items-center justify-center min-h-9 gap-3 px-4',
        'bg-amber-5 text-amber-12 font-medium text-sm',
      )}
    >
      <span className="flex items-center gap-2">
        <span>⚠️</span>
        <span>
          {t('impersonation.banner', {
            userName,
            userEmail: user.email,
            defaultValue: 'You are impersonating {{userName}} ({{userEmail}})',
          })}
        </span>
      </span>
      <button
        className={cn(
          'px-3 py-1 rounded text-xs font-semibold',
          'bg-gray-12 text-white hover:bg-gray-11 transition-colors',
        )}
        onClick={signOut}
      >
        {t('impersonation.stop', { defaultValue: 'Stop' })}
      </button>
    </div>
  )
}
